module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/fsbackground@3x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Background-freespins/fsbackground@3x.jpg
// module id = 180
// module chunks = 0